// removed by extract-text-webpack-plugin
module.exports = {"container":"onfido-sdk-ui-crossDevice-SwitchDevice-container","switchClickableArea":"onfido-sdk-ui-crossDevice-SwitchDevice-switchClickableArea","copy":"onfido-sdk-ui-crossDevice-SwitchDevice-copy","header":"onfido-sdk-ui-crossDevice-SwitchDevice-header","submessage":"onfido-sdk-ui-crossDevice-SwitchDevice-submessage","icon":"onfido-sdk-ui-crossDevice-SwitchDevice-icon","chevron":"onfido-sdk-ui-crossDevice-SwitchDevice-chevron"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/SwitchDevice/style.css
// module id = 396
// module chunks = 1